"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEventDetails = exports.createTrackedEvent = void 0;
/**
 * Convert an `EventDetails` → `TrackedEvent` object. If no graphite name is
 * specified, the event name will be used as the graphite name.
 *
 * @example
 *   createTrackedEvent('eventA', { thresholds: [100, 200] });
 *   // {
 *   //   eventA: {
 *   //     graphiteName: 'eventA',
 *   //     thresholds: { delighted: 100, satisfied: 200 }
 *   //   }
 *   // }
 *
 *   createTrackedEvent('eventB', {
 *     graphiteName: 'custom-graphite-name',
 *     thresholds: [300, 400]
 *   });
 *   // {
 *   //   eventB: {
 *   //     graphiteName: 'custom-graphite-name',
 *   //     thresholds: { delighted: 300, satisfied: 400 }
 *   //   }
 *   // }
 */
function createTrackedEvent(eventName, eventDetails) {
    const trackedEventDetails = {};
    const { graphiteName, isDynamic, thresholds } = eventDetails;
    // Slight differerence between the flag name between the `TrackedEvent`
    // and `EventDetails` types, so make that conversion here.
    if (isDynamic !== undefined)
        trackedEventDetails.dynamicEvent = true;
    // Set the graphite name if specified, otherwise use the event name.
    if (graphiteName !== undefined) {
        trackedEventDetails.graphiteName = eventDetails.graphiteName;
    }
    else
        trackedEventDetails.graphiteName = eventName;
    if (Array.isArray(thresholds)) {
        const [delighted, satisfied] = thresholds;
        trackedEventDetails.thresholds = { delighted, satisfied };
    }
    return { [eventName]: trackedEventDetails };
}
exports.createTrackedEvent = createTrackedEvent;
/**
 * Convert a `TrackedEvent` → `EventDetails` object.
 *
 * @example
 *   createEventDetails({
 *     eventA: {
 *       thresholds: { delighted: 100, satisfied: 200 }
 *     }
 *   });
 *   // { thresholds: [100, 200] }
 */
function createEventDetails(trackedEvent) {
    const eventName = Object.keys(trackedEvent)[0];
    const { dynamicEvent, graphiteName, thresholds } = trackedEvent[eventName];
    const eventDetails = {};
    if ((thresholds === null || thresholds === void 0 ? void 0 : thresholds.delighted) !== undefined &&
        (thresholds === null || thresholds === void 0 ? void 0 : thresholds.satisfied) !== undefined) {
        const { delighted, satisfied } = thresholds;
        eventDetails.thresholds = [delighted, satisfied];
    }
    // No need to include the graphite name if it matches the event name
    // b/c it's assumed the event name will be used as the graphite name
    // if no graphite name is specified.
    if (graphiteName !== undefined && graphiteName !== eventName) {
        eventDetails.graphiteName = graphiteName;
    }
    // Slight difference between the flag name between the `TrackedEvent`
    // and `EventDetails` types, so make that conversion here.
    if (dynamicEvent !== undefined)
        eventDetails.isDynamic = dynamicEvent;
    return eventDetails;
}
exports.createEventDetails = createEventDetails;
